import { controls,grouped } from "../controls";
const product_deposits = {
label: "Product Deposits",
pageLabel: "Product Deposits",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Auto Renew After Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "auto_renew_after_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fixed Auto Renew Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "fixed_auto_renew_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Fixed Auto Renew Month",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "fixed_auto_renew_month",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Renew Min Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "renew_min_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Autorenew Grace Days",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "autorenew_grace_days",maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Flexi GL",star:false}),
...controls.oc({ tab: "general", c: "GL", placeHolder: "Flexi GL", name: "gl_code",fastpath: "gls",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "gl_display"}),
...controls.displayText({ tab: "general", label: "Min Flexi Balance"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "min_flexi_balance",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Flexi Fd Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "min_flexi_fd_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Rd Penal At Receipt"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "rd_penal_at_receipt",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Premature Int Rate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "premature_int_rate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Inst Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "min_inst_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Max Inst Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "max_inst_amount",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Min Interest"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "min_interest",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "AfterMatureRate"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "AfterMatureRate",maxlength:8}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Auto Renew",default:false, name: "is_auto_renew" }),
...controls.checkBox({ tab: "general", label: "Is Rd Mat Month End",default:false, name: "is_rd_mat_month_end" }),
...controls.checkBox({ tab: "general", label: "Include Opening",default:false, name: "include_opening" }),
...controls.checkBox({ tab: "general", label: "Is Auto Renew Same",default:false, name: "is_auto_renew_same" }),
...controls.checkBox({ tab: "general", label: "Is Premature Saving Rate",default:false, name: "is_premature_saving_rate" }),
...controls.checkBox({ tab: "general", label: "Is Premature Saving Rate Year",default:false, name: "is_premature_saving_rate_year" }),
...controls.checkBox({ tab: "general", label: "Is Premature Rate Compare",default:false, name: "is_premature_rate_compare" }),
...controls.checkBox({ tab: "general", label: "Is Trn Below Minbal",default:false, name: "is_trn_below_minbal" }),
...controls.checkBox({ tab: "general", label: "Is Premature Penalty",default:false, name: "is_premature_penalty" }),
...controls.checkBox({ tab: "general", label: "Is Flexi",default:false, name: "is_flexi" }),
...controls.checkBox({ tab: "general", label: "Is Rect No Require",default:false, name: "is_rect_no_require" }),
...controls.checkBox({ tab: "general", label: "Is Multiple Fd Inst",default:false, name: "is_multiple_fd_inst" }),
...controls.checkBox({ tab: "general", label: "Is Installment Type",default:false, name: "is_installment_type" }),
...controls.checkBox({ tab: "general", label: "Active",default:true, name: "product_deposit_active" }),
]
,history:{
perPage: 10,
reportHeader: "Product Deposits",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Is Installment Type",accessor: "is_installment_type",type:'tick'},
]}};
export default product_deposits;